import { every, for_each, reduce, some } from "#shared/array.ts";
import assert from "#shared/assert.ts";
export const unsaved_record_identity = /* @__PURE__ */ Symbol(`unsaved record identity`);
let unsaved_record_count = 0;
const value_copier = (keys) => (source) => reduce(keys, {}, (values, key) => {
  values[key] = source[key];
  return values;
});
const tracked_record = ({
  initial,
  id_key,
  db_values: initial_db_values = null,
  is_empty: values_are_empty = (values) => every(Object.keys(initial), (key) => values[key] === initial[key])
}) => {
  const keys = Object.keys(initial);
  const copy_values = value_copier(keys);
  const key = initial_db_values === null ? `unsaved_${unsaved_record_count++}` : initial_db_values[id_key];
  let db_values = $state.raw(initial_db_values);
  let form_values = $state(copy_values(initial_db_values ?? initial));
  const exists_in_the_database_already = () => db_values !== null;
  const value_needs_to_be_saved = (key2) => db_values === null || form_values[key2] !== db_values[key2];
  const needs_to_be_saved = $derived(db_values === null || some(keys, value_needs_to_be_saved));
  const is_empty = $derived(values_are_empty(form_values));
  const values_to_save = $derived(
    db_values === null ? { [id_key]: null, [unsaved_record_identity]: key, ...copy_values(form_values) } : {
      [id_key]: db_values[id_key],
      ...reduce(keys, {}, (changes, key2) => {
        if (value_needs_to_be_saved(key2)) {
          changes[key2] = form_values[key2];
        }
        return changes;
      })
    }
  );
  return {
    key,
    get form_values() {
      return form_values;
    },
    get db_values() {
      return db_values;
    },
    get needs_to_be_saved() {
      return needs_to_be_saved;
    },
    get is_empty() {
      return is_empty;
    },
    get values_to_save() {
      return values_to_save;
    },
    exists_in_the_database_already,
    value_needs_to_be_saved,
    set_values: (values) => {
      db_values = values;
      for_each(keys, (key2) => {
        form_values[key2] = values[key2];
      });
    },
    update_db_values: (values) => {
      if (db_values === null) {
        assert(every(keys, (key2) => key2 in values), `saved values for a record that was not in the database must include every value`);
      } else {
        assert(db_values[id_key] === values[id_key], `saved values carry the id of this record`);
      }
      db_values = { ...db_values, ...values };
    },
    clear: () => {
      db_values = null;
      form_values = copy_values(initial);
    }
  };
};
export default tracked_record;
